// thunks.js
import {
  fetchOrganizationRequest,
  fetchOrganizationSuccess,
  fetchOrganizationFailure,
  fetchSeasonRequest,
  fetchSeasonSuccess,
  fetchSeasonFailure,
  fetchBinMasterRequest,
  fetchBinMasterSuccess,
  fetchBinMasterFailure,
  fetchBinBatchRequest,
  fetchBinBatchSuccess,
  fetchBinBatchFailure,
  fetchDryingRequest,
  fetchDryingSuccess,
  fetchDryingFailure,
   fetchDryingLineRequest,
  fetchDryingLineSuccess,
  fetchDryingLineFailure,
} from "./actions";

import * as api from "../../service/web_service";

// ================= ORGANIZATIONS =================
export const fetchOrganizationsThunk = (userId) => async (dispatch) => {
  dispatch(fetchOrganizationRequest());
  try {
    const data = await api.fetchOrganizations(userId);
    console.log("✅ Organizations loaded:", data);
    dispatch(fetchOrganizationSuccess(data));
    return data;
  } catch (error) {
    console.error("❌ Organizations Error:", error);
    dispatch(fetchOrganizationFailure(error.message || "Failed to fetch organizations"));
    throw error;
  }
};

export const fetchOrganizations = fetchOrganizationsThunk;

// ================= SEASONS =================
export const fetchSeasonsThunk = (userId) => async (dispatch) => {
  dispatch(fetchSeasonRequest());
  try {
    const data = await api.fetchSeasons(userId);
    console.log("✅ Seasons loaded:", data);
    dispatch(fetchSeasonSuccess(data));
    return data;
  } catch (error) {
    console.error("❌ Seasons Error:", error);
    dispatch(fetchSeasonFailure(error.message || "Failed to fetch seasons"));
    throw error;
  }
};

export const fetchSeasons = fetchSeasonsThunk;

// ================= BIN MASTERS =================
export const fetchBinMastersThunk = (userId) => async (dispatch) => {
  dispatch(fetchBinMasterRequest());
  try {
    const data = await api.fetchBinMasters(userId);
    console.log("✅ Bin Masters loaded:", data);
    dispatch(fetchBinMasterSuccess(data));
    return data;
  } catch (error) {
    console.error("❌ Bin Masters Error:", error);
    dispatch(fetchBinMasterFailure(error.message || "Failed to fetch bin masters"));
    throw error;
  }
};

export const fetchBinMasters = fetchBinMastersThunk;

// ================= BIN BATCH =================
export const fetchBinBatchThunk = (organizationId, seasonId, binNo, cycleNo) => async (dispatch) => {
  dispatch(fetchBinBatchRequest());
  try {
    const data = await api.fetchBinBatch(organizationId, seasonId, binNo, cycleNo);
    console.log("✅ Bin Batch loaded:", data);
    dispatch(fetchBinBatchSuccess(data));
    return data;
  } catch (error) {
    console.error("❌ Bin Batch Error:", error);
    dispatch(fetchBinBatchFailure(error.message || "Failed to fetch bin batch data"));
    throw error;
  }
};

export const fetchBinBatch = fetchBinBatchThunk;

// ================= DRYING =================
export const fetchDryingThunk = () => async (dispatch) => {
  dispatch(fetchDryingRequest());

  try {
    const userId = sessionStorage.getItem("userId");

    console.log("=== Fetching Drying Data ===");
    console.log("UserId:", userId);

    const data = await api.fetchDrying(userId);

    console.log("✅ Drying data loaded:", data);

    dispatch(fetchDryingSuccess(data));

    return data;
  } catch (error) {
    console.error("❌ Drying Error:", error);

    dispatch(
      fetchDryingFailure(
        error.message || "Failed to fetch drying data"
      )
    );

    throw error;
  }
};

export const fetchDryingData = fetchDryingThunk;


// ================= DRYING LINE =================
export const fetchDryingLineThunk = (dryingId) => async (dispatch) => {
  dispatch(fetchDryingLineRequest());
  try {
    const data = await api.fetchDryingLine(dryingId);
    console.log("✅ Drying Line data loaded:", data);
    dispatch(fetchDryingLineSuccess(data));
    return data;
  } catch (error) {
    console.error("❌ Drying Line Error:", error);
    dispatch(fetchDryingLineFailure(error.message || "Failed to fetch drying line data"));
    throw error;
  }
};

export const fetchDryingLineData = fetchDryingLineThunk;

export const fetchTypeOfDryer = (userId) => async (dispatch) => {
  try {
    dispatch({ type: 'FETCH_TYPE_OF_DRYER_REQUEST' });
    const response = await fetch(`/your-api-endpoint/type-of-dryer?userId=${userId}`);
    const data = await response.json();
    dispatch({ type: 'FETCH_TYPE_OF_DRYER_SUCCESS', payload: data });
  } catch (error) {
    dispatch({ type: 'FETCH_TYPE_OF_DRYER_FAILURE', error: error.message });
  }
};


